module.exports = __webpack_public_path__ + "img/vertical_4_3_1.c231afe6.png";